export default "__VITE_ASSET__C5x0V$YF__"